// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mobile-text[data-v-5c557692] {\n  display: inline;\n}\n@media screen and (max-width: 400px) {\n.mobile-text[data-v-5c557692] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
